onDomReady(() => {
   let drawer = $('drawer');
   let menuButton = $('menuButton');
   let wrap = $('wrap');
   let nav = $('nav');

   if (menuButton) {
      menuButton.addEvent('click', ev => {
         ev.stop();
         drawer.toggleClass('active');
         wrap.toggleClass('active');
         nav.toggleClass('active');
         menuButton.toggleClass('active');
      });
   }
});
